import { render, staticRenderFns } from "./crmReport.vue?vue&type=template&id=63a10c91&"
import script from "./crmReport.vue?vue&type=script&lang=js&"
export * from "./crmReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports